import { compose, defaultProps, withProps } from 'recompose';
import * as T from '@components/exportButton/_exportButtonTypes';

export const enhanceExportButton = compose<T.EnhancedExportBtnProps, T.EnhancedExportProps>(
  defaultProps({
    exportLabel: 'Export',
    location: 'unknownOverview',
    formName: 'not-defined',
    urlPrefix: '/metropolis'
  }),
  withProps(({ params: { sort, order, page, pageSize, filters, checkedItems, universalFilter } }) => ({
    input: {
      params: checkedItems.length
        ? {
            filter: [
              {
                field: null,
                operation: 'OR',
                value: null,
                filter: [...checkedItems.map(item => ({ operation: 'EQ', field: 'id', value: item.id }))]
              }
            ],
            pageSize: -1
          }
        : {
            operation: 'AND',
            filter: [
              ...(filters.length
                ? [
                    {
                      field: null,
                      operation: 'AND',
                      value: null,
                      filter: [...filters]
                    }
                  ]
                : [])
            ],
            universalFilter: universalFilter ? { value: universalFilter } : undefined,
            sort,
            order,
            page,
            pageSize
          }
    }
  }))
);



// WEBPACK FOOTER //
// ./src/components/exportButton/enhancer.ts